module.exports = __webpack_public_path__ + "img/e.f30992d9.svg";